<template>

  <div class="column is-one-fifth sidebar">
   <aside class="menu">
      <p class="menu-label">
        General
      </p>
      <ul class="menu-list">
        <li><a>Dashboard</a></li>
        <li><a>Customers</a></li>
      </ul>
      <p class="menu-label">
        Administration
      </p>
      <ul class="menu-list">
        <li><a>Team Settings</a></li>
        <li>
          <a class="is-active">Manage Your Team</a>
          <ul>
            <li><a>Members</a></li>
            <li><a>Plugins</a></li>
            <li><a>Add a member</a></li>
          </ul>
        </li>
        <li><a>Invitations</a></li>
        <li><a>Cloud Storage Environment Settings</a></li>
        <li><a>Authentication</a></li>
      </ul>
      <p class="menu-label">
        Account
      </p>
      <ul class="menu-list">
        <li><a>User Account</a></li>
        <li><a>Manage Subscription</a></li>
      </ul>
    </aside>
  </div>

</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Sidebar',
  data() {
    return {
    };
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.replace('login');
        this.$toast.open({
          message: 'Successfully logged out!',
          position: 'is-bottom',
          type: 'is-success',
        });
      });
    },
  },
};
</script>

<style scoped>
.sidebar .menu {
  background: #2a2a2a;
  color: #fff;
  padding: 20px;
}

.sidebar .menu .menu-list a {
  border-radius: 2px;
  color: #a8a8a8;
  display: block;
  padding: 0.5em 0.75em;
}

.sidebar .menu .menu-list a:hover {
  color: #2a2a2a;
}

.sidebar .menu .menu-list a.is-active {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue